import { EngineServicePartnerActionTypes } from './actionTypes'
import { AccountData } from '../../../common/modules/partner/action'

export interface EngineServicePartnerState {
  engineServicePartnerData: AccountData | null
  // Separate selected account data for form display (doesn't affect onboarding validation)
  selectedEngineServicePartnerData: AccountData | null
  selectedAccountId?: string // Track which account is currently selected
}

const initialState: EngineServicePartnerState = {
  engineServicePartnerData: null,
  selectedEngineServicePartnerData: null,
  selectedAccountId: undefined,
}

export const engineServicePartnerReducer = (
  state = initialState,
  action: { type: EngineServicePartnerActionTypes; payload: any }
): EngineServicePartnerState => {
  switch (action.type) {
    case EngineServicePartnerActionTypes.SET_ENGINE_SERVICE_PARTNER_DATA:
      const currentPartnerId = state.engineServicePartnerData?.partnerId
      const newPartnerId = action.payload?.partnerId

      // If partnerId is null, clear the entire state (replace with null)
      if (newPartnerId === null || newPartnerId === undefined) {
        return {
          ...state,
          engineServicePartnerData: null,
        }
      }

      // If partnerId changed, replace instead of merge to prevent stale data
      if (currentPartnerId && currentPartnerId !== newPartnerId) {
        return {
          ...state,
          engineServicePartnerData: action.payload as AccountData,
        }
      }

      // Otherwise merge (for updates to same partner)
      // IMPORTANT: Always preserve partnerId from existing state to prevent data mismatch
      return {
        ...state,
        engineServicePartnerData: {
          ...(state.engineServicePartnerData || {}),
          ...action.payload,
          // Ensure partnerId is preserved - partial updates might not include it
          partnerId:
            state.engineServicePartnerData?.partnerId ||
            action.payload?.partnerId,
        } as AccountData,
      }
    case EngineServicePartnerActionTypes.SET_SELECTED_ENGINE_SERVICE_PARTNER_DATA:
      return {
        ...state,
        selectedEngineServicePartnerData: action.payload as AccountData,
        selectedAccountId: action.payload?.partnerId,
      }
    case EngineServicePartnerActionTypes.CLEAR_SELECTED_ENGINE_SERVICE_PARTNER_DATA:
      return {
        ...state,
        selectedEngineServicePartnerData: null,
        selectedAccountId: undefined,
      }
    default:
      return state
  }
}
